import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
export var convertToInvoice = function (invoiceDto, timeZone, masterData) {
    var _a, _b;
    return {
        id: invoiceDto.id,
        uuid: invoiceDto.uuid,
        customer: convertToCustomer(invoiceDto),
        business: convertToBusiness(invoiceDto),
        invoiceDate: invoiceDto.issued_at === null ? moment().tz(timeZone) : moment(invoiceDto.issued_at).tz(timeZone),
        appointmentDate: moment(invoiceDto.appt_date).tz(timeZone),
        dropOff: moment(invoiceDto.drop_off).tz(timeZone),
        pickUp: moment(invoiceDto.pick_up).tz(timeZone),
        duration: convertToDuration(invoiceDto),
        tax: convertToTax(invoiceDto),
        subtotal: invoiceDto.subtotal,
        total: invoiceDto.total,
        grandTotal: invoiceDto.grand_total,
        lines: ((_a = invoiceDto.invoice_lines) !== null && _a !== void 0 ? _a : []).map(function (lineDto) { return convertToLine(lineDto, invoiceDto.invoice_lines_with_tax, timeZone); }),
        bookingId: invoiceDto.booking_id,
        number: invoiceDto.number,
        tip: invoiceDto.tip_amount || invoiceDto.tip_percentage
            ? { amount: invoiceDto.tip_amount, percentage: invoiceDto.tip_percentage }
            : null,
        tipDistribution: ((_b = invoiceDto.tips) !== null && _b !== void 0 ? _b : []).map(function (tipDistribution) { return ({
            id: tipDistribution.id,
            uuid: tipDistribution.uuid,
            amount: tipDistribution.amount,
            staff: {
                id: tipDistribution.staff_id,
                name: tipDistribution.staff_name,
                imageUrl: tipDistribution.staff_image,
            },
        }); }),
        pdfUrl: invoiceDto.pdf_file_url,
        paymentType: masterData.paymentTypes.find(function (paymentType) { return paymentType.id === invoiceDto.payment_type; }),
        deposits: convertToDeposits(invoiceDto),
        payments: convertToPayments(invoiceDto),
        totalDue: invoiceDto.due_total || '0.00',
        discount: invoiceDto.discount,
        version: isEmpty(invoiceDto.version) ? '' : invoiceDto.version,
        balance: invoiceDto.balance,
        createdAt: moment(invoiceDto.created_at).tz(timeZone),
        updatedAt: moment(invoiceDto.updated_at).tz(timeZone),
    };
};
export var convertToDeposits = function (invoiceDto) {
    return {
        list: (invoiceDto.deposits || []).map(function (depositDto) { return convertToDeposit(depositDto); }),
        total: invoiceDto.deposits_total || '0.00',
        unpaidTotal: invoiceDto.deposits_unpaid_total || '0.00',
    };
};
export var convertToPayments = function (invoiceDto) {
    return {
        total: invoiceDto.payments_total || '0.00',
        totalWithoutDeposits: (Number(invoiceDto.payments_total || '0.00') - Number(invoiceDto.deposits_total || '0.00')).toFixed(2),
    };
};
export var convertToDeposit = function (dto) {
    return {
        id: dto.id,
        uuid: dto.uuid,
        amount: dto.amount,
        appointmentId: dto.appointment_id,
        clientId: dto.customer_id,
        invoiceId: dto.invoice_id,
        paid: dto.paid,
    };
};
var convertToCustomer = function (invoiceDto) {
    return {
        id: invoiceDto.customer_id,
        name: invoiceDto.customer_name,
        phone: invoiceDto.customer_phone,
        email: invoiceDto.customer_email,
        address: invoiceDto.customer_address,
    };
};
var convertToBusiness = function (invoiceDto) {
    return {
        name: invoiceDto.business_name,
        address: invoiceDto.address,
        logoUrl: invoiceDto.logo_url,
    };
};
var convertToTax = function (invoiceDto) {
    return {
        rate: invoiceDto.tax_rate,
        amount: invoiceDto.tax,
        detail: invoiceDto.tax_detail,
    };
};
var convertToLine = function (lineDto, linesWithTax, timeZone) {
    var _a;
    var taxesDto = isEmpty(lineDto.tax_data) ? [] : JSON.parse(lineDto.tax_data);
    return {
        id: lineDto.id,
        uuid: lineDto.uuid,
        productId: lineDto.business_product_id,
        addOnServiceId: lineDto.addon_service_id,
        appoitnmentId: lineDto.appointment_id,
        service: convertToService(lineDto),
        description: lineDto.description,
        quantity: lineDto.quantity,
        discount: convertToDiscount(lineDto),
        subtotal: lineDto.amount,
        total: lineDto.total,
        totalWithTax: ((_a = linesWithTax.find(function (tax) { return tax.uuid === lineDto.uuid; })) === null || _a === void 0 ? void 0 : _a.value) || lineDto.total,
        pet: convertToPet(lineDto),
        staff: convertToStaff(lineDto),
        isProduct: lineDto.business_product_id !== null,
        isAddOnService: (lineDto.addon_service_id || null) !== null,
        taxesAmount: lineDto.tax_amount || '0.00',
        taxes: taxesDto.map(function (taxDto) { return ({
            id: taxDto.id,
            uuid: taxDto.uuid,
            name: taxDto.name,
            percentage: taxDto.value,
        }); }),
        createdAt: moment(lineDto.created_at).tz(timeZone),
        updatedAt: moment(lineDto.updated_at).tz(timeZone),
        orderItemId: lineDto.order_item_id,
    };
};
var convertToService = function (lineDto) {
    return lineDto.service_id === null
        ? null
        : {
            id: lineDto.service_id,
            name: lineDto.service_name,
        };
};
var convertToDiscount = function (lineDto) {
    return {
        percentage: lineDto.discount_percentage || undefined,
        amount: lineDto.discount_amount,
    };
};
var convertToPet = function (lineDto) {
    return lineDto.pet_id
        ? {
            id: lineDto.pet_id,
            name: lineDto.pet_name,
            hasMedicalRecord: lineDto.pet_has_medical_record,
            breed: lineDto.pet_breed,
            type: lineDto.pet_type,
            imageUrl: lineDto.pet_image_url,
        }
        : undefined;
};
var convertToStaff = function (lineDto) {
    return lineDto.staff_name
        ? {
            id: lineDto.staff_id,
            name: lineDto.staff_name,
            imageUrl: lineDto.staff_image,
        }
        : undefined;
};
var convertToDuration = function (invoiceDto) {
    return {
        hours: Math.trunc(invoiceDto.estimate_duration_in_minutes / 60),
        minutes: invoiceDto.estimate_duration_in_minutes % 60,
    };
};
export var convertToAdminInvoice = function (dto, timeZone) { return ({
    id: dto.id,
    uuid: dto.uuid,
    clientId: dto.client_id,
    subscriptionId: dto.subscription_id,
    number: dto.number,
    clientType: dto.client_type,
    paymentType: dto.payment_type,
    tipAmount: dto.tip_amount,
    taxRate: dto.tax_rate,
    paidInFull: dto.paid_in_full,
    tax: dto.tax,
    subtotal: dto.subtotal,
    total: dto.total,
    discount: dto.discount,
    grandTotal: dto.grand_total,
    invoiceLines: dto.admin_invoice_lines.map(function (line) { return convertToAdminInvoiceLine(line, timeZone); }),
    pdfUrl: dto.pdf_file_url,
    issuedAt: moment(dto.issued_at).tz(timeZone),
    createdAt: moment(dto.created_at).tz(timeZone),
    updatedAt: moment(dto.updated_at).tz(timeZone),
}); };
export var convertToAdminInvoiceLine = function (dto, timeZone) { return ({
    id: dto.id,
    uuid: dto.uuid,
    adminInvoiceId: dto.admin_invoice_id,
    description: dto.description,
    quantity: dto.quantity,
    amount: dto.amount,
    total: dto.total,
    discount_amount: dto.discount_amount,
    discount_percentage: dto.discount_percentage,
    created_at: moment(dto.created_at).tz(timeZone),
    updated_at: moment(dto.updated_at).tz(timeZone),
}); };
